import { http } from '../../config/axios'

export default function postCancelarCliente(cliente: { id: string, motivoCancelamento: string }): Promise<string> {
  return http
    .post('api/client/cancelar', cliente)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post cancelar cliente', error)
      throw Error(error.response.data)
    })
}
